import {Component} from '@angular/core';
import 'rxjs/add/operator/map';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    constructor(private router: Router) {
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts